import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Pip from '../assets/icons/custom/pip.svg?react';

export function PipIcon(props: SvgIconProps) {
  return <SvgIcon component={Pip} inheritViewBox {...props} />;
}
